import React from 'react';
import './Image.style.css';

const Image = (props) => {
  /* ===== Route ===== */
  /* ===== Props ===== */
  const {
    src = null,
    alt = null,
    width,
    height,
    fit = 'cover',
    objectPosition = 'none',
    style = {},
    fallback = null,
    noImageText = 'No Image',
    noImageStyle = {},
    radius = 0,
  } = props;
  /* ===== State ===== */
  const imageWrapRef = React.useRef(null);
  const [imageWidth, setImageWidth] = React.useState(0);

  /* ===== Hooks ===== */
  /* ===== Function ===== */
  /* ===== Variable ===== */
  /* ===== Hooks ===== */
  React.useEffect(() => {
    if (imageWrapRef.current) {
      const { clientWidth } = imageWrapRef.current;
      setImageWidth(clientWidth);
    }
  }, [imageWrapRef]);

  /* ===== Render ===== */
  return (
    <div
      ref={imageWrapRef}
      className="image-wrapper"
      style={{ width: width, height: height, borderRadius: radius, ...style }}
    >
      {src ? (
        <img
          src={src}
          alt={alt ?? '이미지'}
          width={'100%'}
          height={'100%'}
          style={{ objectFit: fit, borderRadius: radius, objectPosition: style?.objectPosition }}
        />
      ) : fallback ? (
        fallback
      ) : (
        <p style={{ fontSize: imageWidth * 0.1, ...noImageStyle }}>
          {noImageText}
        </p>
      )}
    </div>
  );
};

export default Image;
